var map = {
	"./communications.jpeg": "1388",
	"./compliance.png": "6411",
	"./dataprotection.jpg": "96f7",
	"./malware.png": "4526",
	"./passwords.png": "8392",
	"./socialengineering.png": "b0be",
	"./workplace.png": "a014"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d250";